import { styled, DualSlider } from '@innowise-group/mui-kit';

export const CurrenciesSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
`;

export const CurrencyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const ControlsContainer = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const CurrencyTitle = styled.span`
  display: inline-flex;
  ${({ theme }) => theme.fonts.primary[20]}
`;

export const CurrencyLabel = styled(CurrencyTitle)`
  font-weight: 600;
`;

export const RangePrice = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const RangePriceField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const RangePriceLabel = styled.label`
  ${({ theme }) => theme.fonts.primary[20]}
`;

export const RangePriceInput = styled.input`
  ${({ theme }) => theme.fonts.primary[20]}
  padding: 10px;
  border-radius: 4px;
  outline: none;
  border: 1px solid ${({ theme }) => theme.palette.general.lightGrey[80]};
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const CustomDualSlider = styled(DualSlider)`
  padding: 40px 10px 25px 10px;
`;

export const Title = styled.h1`
  text-align: center;
  margin-bottom: 10px;
  ${({ theme }) => theme.fonts.primary[90]}
  color: ${({ theme }) => theme.palette.general.darkGrey[80]}
`;
